import React, { useState, useEffect } from 'react';
import { roleMapping } from '../../../helpers/transformations';
import './role-checkbox-list.scss'

export const roles = roleMapping;

export default function RoleCheckboxList({ initialRoles = [], onChange }) {
    const [selectedRoles, setSelectedRoles] = useState([]);

    const toggleRole = (roleId) => {
        setSelectedRoles(prev => {
            let updated;

            if (prev.includes(roleId)) {
                updated = prev.filter(id => id !== roleId);
            } else {
                updated = [...prev, roleId];
            }
            return updated;
        });
    };

    const sortedRoleEntries = Object.entries(roles)
        .map(([id, name]) => ({ id: Number(id), name }))
        .sort((a, b) => a.id - b.id);

    // initialize from user roles
    useEffect(() => {
        setSelectedRoles(initialRoles);
    }, [initialRoles]);


    // notify parent component outside of toggle function to prevent console error 
    useEffect(() => {
        onChange?.(selectedRoles);
    }, [selectedRoles, onChange]);

    return (
        <div className="role-checkbox-list">
            {sortedRoleEntries.map(role => (
                <label key={role.id} className="role-checkbox-item">
                    <input
                        type="checkbox"
                        checked={selectedRoles.includes(role.id)}
                        onChange={() => toggleRole(role.id)}
                    />
                    <span>{role.name}</span>
                </label>
            ))}
        </div>
    );
}
